import UIButton from 'UIComponents/button/UIButton';
import styled, { css } from 'foundations-theming-specialty/utils';
import { fwcColor } from 'foundations-theming/utils/fwc';
import { BREEZE_SPECIAL } from '../../../../constants/BreezeUse';
const DropdownButtonIconStyle = css([".uiDropdown__buttonContents{display:inline-block;.uiDropdown__buttonLabel{margin-right:", ";}}[class^='AbstractDropdown']{display:inline;[class^='DropdownCaret']{margin-left:", ";}}"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200']);
const IconStyle = css([".ai-icon{position:relative;}"]);
export const BreezePrimaryAIBaseButton = styled(UIButton).withConfig({
  shouldForwardProp: prop => prop !== 'cssstyles'
}).withConfig({
  displayName: "StyledAIBaseButton__BreezePrimaryAIBaseButton"
})(["border-radius:", " !important;color:", " !important;border:none !important;background:", " !important;&:hover{background:", " !important;}&:active{background:", " !important;}", " ", " &&&{", " &.disabled{color:", " !important;border:none !important;background:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color[fwcColor('fwc-ai-button-fill-primary-default')], ({
  theme
}) => theme.color[fwcColor('fwc-ai-button-fill-primary-hover')], ({
  theme
}) => theme.color[fwcColor('fwc-ai-button-fill-primary-pressed')], DropdownButtonIconStyle, IconStyle, ({
  cssstyles
}) => cssstyles, ({
  theme
}) => theme.color['breeze-text-component-disabled'], ({
  theme
}) => theme.color['breeze-fill-primary-disabled']);
export const BreezeSecondaryAIBaseButton = styled(UIButton).withConfig({
  shouldForwardProp: prop => prop !== 'cssstyles'
}).withConfig({
  displayName: "StyledAIBaseButton__BreezeSecondaryAIBaseButton"
})(["border-radius:", " !important;", " ", " &&&{border:1px solid transparent !important;color:", " !important;background:", " !important;&:hover{border:1px solid transparent !important;color:", " !important;background:", " !important;}&:active{border:1px solid transparent !important;color:", " !important;background:", " !important;}", " &.disabled{color:", " !important;border-color:", " !important;background:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], DropdownButtonIconStyle, IconStyle, ({
  theme
}) => theme.color['breeze-text-secondary-default'], ({
  theme
}) => `linear-gradient(${theme.color['breeze-fill-secondary-default']}, ${theme.color['breeze-fill-secondary-default']}) padding-box, linear-gradient(${theme.color['fill-surface-default']}, ${theme.color['fill-surface-default']}) padding-box, ${theme.color[fwcColor('fwc-ai-button-border-secondary-default')]} border-box`, ({
  theme
}) => theme.color['breeze-text-secondary-hover'], ({
  theme
}) => `linear-gradient(${theme.color['breeze-fill-secondary-hover']}, ${theme.color['breeze-fill-secondary-hover']}) padding-box, linear-gradient(${theme.color['fill-surface-default']}, ${theme.color['fill-surface-default']}) padding-box, ${theme.color[fwcColor('fwc-ai-button-border-secondary-hover')]} border-box`, ({
  theme
}) => theme.color['breeze-text-secondary-pressed'], ({
  theme
}) => `linear-gradient(${theme.color['breeze-fill-secondary-pressed']}, ${theme.color['breeze-fill-secondary-pressed']}) padding-box, linear-gradient(${theme.color['fill-surface-default']}, ${theme.color['fill-surface-default']}) padding-box, ${theme.color[fwcColor('fwc-ai-button-border-secondary-pressed')]} border-box`, ({
  cssstyles
}) => cssstyles, ({
  theme
}) => theme.color['breeze-text-component-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed'], ({
  theme
}) => theme.color['breeze-fill-secondary-disabled']);
export const BreezeTertiaryAIBaseButton = styled(UIButton).withConfig({
  shouldForwardProp: prop => prop !== 'cssstyles'
}).withConfig({
  displayName: "StyledAIBaseButton__BreezeTertiaryAIBaseButton"
})(["border-radius:", " !important;", " ", " &&&{color:", " !important;border:1px solid ", " !important;background:", " !important;&:hover{color:", " !important;background:", " !important;}&:active{color:", " !important;background:", " !important;}", " &.disabled{color:", " !important;border:1px solid ", " !important;background:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], DropdownButtonIconStyle, IconStyle, ({
  theme
}) => theme.color['breeze-text-tertiary-default'], ({
  theme
}) => theme.color['breeze-border-tertiary-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['breeze-text-tertiary-default'], ({
  theme
}) => theme.color['breeze-fill-tertiary-hover'], ({
  theme
}) => theme.color['breeze-text-tertiary-default'], ({
  theme
}) => theme.color['breeze-fill-tertiary-pressed'], ({
  cssstyles
}) => cssstyles, ({
  theme
}) => theme.color['breeze-text-component-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed'], ({
  theme
}) => theme.color['breeze-fill-primary-disabled']);
export const BreezeSpecialAIBaseButton = styled(UIButton).withConfig({
  shouldForwardProp: prop => prop !== 'cssstyles'
}).withConfig({
  displayName: "StyledAIBaseButton__BreezeSpecialAIBaseButton"
})(["border-radius:", " !important;&:not(.disabled){background:", " !important;color:", " !important;border:none !important;&:hover{background:", ";}&:active{background:", ";}}", " ", " &&&{", " &.disabled{color:", " !important;border-color:", " !important;background:", " !important;}}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.color['breeze-fill-special-btn-alt-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color[fwcColor('fwc-ai-button-fill-primary-hover')], ({
  theme
}) => theme.color[fwcColor('fwc-ai-button-fill-primary-pressed')], DropdownButtonIconStyle, IconStyle, ({
  cssstyles
}) => cssstyles, ({
  theme
}) => theme.color['breeze-text-component-disabled'], ({
  theme
}) => theme.color['border-core-subtle-pressed'], ({
  theme
}) => theme.color['breeze-fill-primary-disabled']);
export const BreezeTransparentAIBaseButton = styled(UIButton).withConfig({
  shouldForwardProp: prop => prop !== 'cssstyles'
}).withConfig({
  displayName: "StyledAIBaseButton__BreezeTransparentAIBaseButton"
})(["border-radius:", " !important;", " ", " &&&{color:", " !important;border:none !important;background:transparent !important;&:not(.disabled):hover{color:", " !important;background:", " !important;}&:not(.disabled):active{color:", " !important;background:", " !important;}", " &.disabled{color:", " !important;border-color:transparent !important;}}"], ({
  theme
}) => theme.borderRadius['full'], DropdownButtonIconStyle, IconStyle, ({
  theme
}) => theme.color['breeze-text-transparent-default'], ({
  theme
}) => theme.color['breeze-text-transparent-default'], ({
  theme
}) => theme.color['breeze-fill-tertiary-hover'], ({
  theme
}) => theme.color['breeze-text-transparent-default'], ({
  theme
}) => theme.color['breeze-fill-tertiary-pressed'], ({
  cssstyles
}) => cssstyles, ({
  theme
}) => theme.color['breeze-text-component-disabled']);
export const getStyledAIButton = use => {
  switch (use) {
    case BREEZE_SPECIAL:
      return BreezeSpecialAIBaseButton;
    case 'primary':
      return BreezePrimaryAIBaseButton;
    case 'secondary':
      return BreezeSecondaryAIBaseButton;
    case 'tertiary':
      return BreezeTertiaryAIBaseButton;
    case 'transparent':
      return BreezeTransparentAIBaseButton;
    default:
      return BreezePrimaryAIBaseButton;
  }
};